var map = {
	"./about.png": 6447,
	"./boards.png": 7301,
	"./com-detail.png": 6269,
	"./commission.png": 3861,
	"./const.png": 2629,
	"./contact.png": 5440,
	"./copyrights.png": 9260,
	"./gallery.png": 2338,
	"./internalcom.png": 3534,
	"./internaldoc.png": 3211,
	"./legislation.png": 9047,
	"./leisure.png": 509,
	"./links.png": 8443,
	"./news.png": 1327,
	"./partners.png": 1291,
	"./personal.png": 7094,
	"./publications.png": 1507,
	"./seminars.png": 9306,
	"./social.png": 4619
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1293;